__turbopack_context__.v({
  "actionLink": "AnalysisCategory-module__zeQzJq__actionLink",
  "actionWrapper": "AnalysisCategory-module__zeQzJq__actionWrapper",
  "badge": "AnalysisCategory-module__zeQzJq__badge",
  "badgeClickable": "AnalysisCategory-module__zeQzJq__badgeClickable",
  "blurredList": "AnalysisCategory-module__zeQzJq__blurredList",
  "card": "AnalysisCategory-module__zeQzJq__card",
  "header": "AnalysisCategory-module__zeQzJq__header",
  "headerTitle": "AnalysisCategory-module__zeQzJq__headerTitle",
  "iconWrapper": "AnalysisCategory-module__zeQzJq__iconWrapper",
  "list": "AnalysisCategory-module__zeQzJq__list",
  "subtitle": "AnalysisCategory-module__zeQzJq__subtitle",
  "texts": "AnalysisCategory-module__zeQzJq__texts",
  "title": "AnalysisCategory-module__zeQzJq__title",
});
